// extracted by mini-css-extract-plugin
export default {"content":"UpdatePassword_content__UKQQG","realContent":"UpdatePassword_realContent__1sL6v"};